import React from 'react'
// libs
import { useDispatch } from 'react-redux'
import { InjectedFormProps, reduxForm, submit } from 'redux-form'
// constants
import { Forms } from 'constants/forms'
// types
import { IObjectEntityReviewQuestion } from 'types/graphql'
// components
import { ReduxInput } from 'components/FormElements'
// icons
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
// views
import { Form, Row, ToggleButton } from './views'
// themes
import { colors } from 'themes'
// utils
import { debounce } from 'lodash'
import { required } from 'utils/validators'

type Fields = Record<string, string>

interface Props {
  questions: IObjectEntityReviewQuestion[]
  onToggle: (id: string) => void
}

const ReviewQuestionsForm: React.FC<InjectedFormProps<Fields> & Props> = ({ questions, onToggle, handleSubmit }) => {
  const dispatch = useDispatch()

  const onChange = React.useCallback(
    debounce(() => dispatch(submit(Forms.OBJECT_REVIEW_QUESTIONS_FORM)), 1000),
    []
  )

  return (
    <Form onSubmit={handleSubmit}>
      {questions.map((question, idx) => {
        const isActive = question.active

        return (
          <Row key={question.id}>
            <ReduxInput
              multiline
              label={`Question ${idx + 1}`}
              validate={[required]}
              name={question.id}
              handleInputChange={onChange}
            />
            <ToggleButton
              data-testid='toggle-review-question'
              data-active={isActive}
              title={isActive ? 'Hide question' : 'Show question'}
              onClick={() => onToggle(question.id)}>
              {isActive ? (
                <Visibility htmlColor={colors.blue500} fontSize='small' />
              ) : (
                <VisibilityOff htmlColor={colors.gray280} fontSize='small' />
              )}
            </ToggleButton>
          </Row>
        )
      })}
    </Form>
  )
}

export default reduxForm<any, any>({
  form: Forms.OBJECT_REVIEW_QUESTIONS_FORM,
  enableReinitialize: false
})(ReviewQuestionsForm)
